'use strict';

const templates = {};
let isSetup = false;

function setup() {
    if (isSetup) return;
    isSetup = true;
    document.querySelectorAll('.templates .template').forEach((templateNode) => {
        if (!templateNode.id) return;
        templates[templateNode.id] = {
            node: templateNode
        };
        templateNode.className = [(templateNode.className || ''), templateNode.id].join(' ');
        templateNode.removeAttribute('id');
    });
}

module.exports = {
    getByName: function (name) {
        setup();
        if (!templates[name]) {
            templates[name] = {
                node: document.createElement('div')
            };
        }
        return templates[name].node;
    }
};

